import React, {memo, useMemo, useState} from 'react';
import {Col, Row, UiBox, UiImage, UiText} from '~/components/elements';
import {spacing} from '~/utils/theme/spacing';
import {AppCarousel} from '~/components/elements/AppCarousel';
import {BoxProps} from '@chakra-ui/react';
import {UserReview} from '~/redux/questionnaires/types';

interface Props extends BoxProps {
  reviewList?: UserReview[];
}

const STAR_LIST = [1, 2, 3, 4, 5];

export const ReviewItem = memo(function ReviewItem({reviewList, ...rest}: Props) {
  const [selectedItem, setSelectedItem] = useState(0);

  const renderList = () =>
    reviewList?.map((item, index) => (
      <UiBox key={item?.content} px={2}>
        <Row display="flex" flex={1} justifyContent="center">
          {STAR_LIST.map(i => (
            <UiImage className="review-star-img" key={i} type="icon" name="star" boxSize={6} mx={2} />
          ))}
        </Row>
        <UiText textAlign="center" fontSize="xs" mt={spacing.tiny} lineHeight={6}>
          {item?.content}
        </UiText>
        <UiText fontWeight="700" mt={spacing.mini}>
          - {item?.userName}
        </UiText>
      </UiBox>
    ));
  return (
    <UiBox w="100%" {...rest}>
      <AppCarousel
        selectedItem={selectedItem}
        onChange={index => setSelectedItem(index)}
        onClickItem={index => setSelectedItem(index)}
        showIndicators={false}
        showArrows={false}
        showStatus={false}
        showThumbs={false}
        autoPlay
        infiniteLoop
      >
        {renderList()}
      </AppCarousel>
    </UiBox>
  );
});
